"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var classnames_1 = __importDefault(require("classnames"));
var ButtonLink_1 = require("../ButtonLink");
var FilterButtonSimple = function (_a) {
    var color = _a.color, selected = _a.selected, children = _a.children, onClick = _a.onClick;
    return ((0, jsx_runtime_1.jsx)(ButtonLink_1.ButtonLink, __assign({ className: (0, classnames_1.default)('btn-filter', "style-".concat(color), { selected: selected }), noMargin: true, onClick: onClick }, { children: children })));
};
exports.default = FilterButtonSimple;
